import { globalAgent } from 'https';

export function getSwitch(key, config?) {
    return (function (window: any) {
        return window.__INITIAL_STATE__ ? window.__INITIAL_STATE__?.switchs && window.__INITIAL_STATE__.switchs[key] : config?.switchs && config.switchs[key];
    })(global) ;
}

export const switchKeys = {
    UPM: 'upm',
};
